import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from './SetStoreName.module.css';
import axios from 'axios';
import { URL } from '../AxiosUrlGlobal';

/* ─── Inline icons ─────────────────────────────────────────────── */
const ArrowRight = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
    </svg>
);

const Check = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

const StoreIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l1.5-6h15L21 9M3 9v11a1 1 0 001 1h16a1 1 0 001-1V9M3 9h18M9 21V12h6v9" />
    </svg>
);

const GlobeIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
    </svg>
);

const InfoIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="16" x2="12" y2="12" />
        <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
);

const AlertIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
);

function SetStoreName() {
    const [storeName, setStoreName] = useState('');
    const [loading, setLoading] = useState(false);
    const [subdomain, setSubdomain] = useState('');
    const [isValid, setIsValid] = useState(true);
    const [validationMessage, setValidationMessage] = useState('');

    const uid = localStorage.getItem('id');

    useEffect(() => {
        if (storeName) {
            // Strip any leading "e-" the user might type so we don't end up
            // with e-e-store after the backend prefixes it.
            const cleaned = storeName
                .toLowerCase()
                .replace(/[^a-z0-9\s-]/g, '')
                .replace(/\s+/g, '-')
                .replace(/-+/g, '-')
                .replace(/^e-/, '')
                .substring(0, 28); // 28 + "e-" prefix = 30 char subdomain max
            setSubdomain(cleaned);
            validateStoreName(cleaned);
        } else {
            setSubdomain('');
            setIsValid(true);
            setValidationMessage('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [storeName]);

    const validateStoreName = (name) => {
        if (name.length < 2) {
            setIsValid(false);
            setValidationMessage('স্টোরের নাম অন্তত ২ অক্ষরের হতে হবে');
            return false;
        }
        if (name.length > 28) {
            setIsValid(false);
            setValidationMessage('স্টোরের নাম ২৮ অক্ষরের কম হতে হবে');
            return false;
        }
        if (!/^[a-z0-9-]+$/.test(name)) {
            setIsValid(false);
            setValidationMessage('শুধু lowercase letters, numbers, এবং hyphens ব্যবহার করুন');
            return false;
        }
        if (name.startsWith('-') || name.endsWith('-')) {
            setIsValid(false);
            setValidationMessage('শুরুতে বা শেষে hyphen ব্যবহার করা যাবে না');
            return false;
        }
        setIsValid(true);
        setValidationMessage('সব ঠিক আছে!');
        return true;
    };

    const handleStoreName = async () => {
        if (!storeName || storeName.trim() === '') {
            toast.error('আপনার স্টোরের নাম লিখুন');
            return;
        }
        if (!isValid) {
            toast.error(validationMessage);
            return;
        }

        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.post(
                `${URL}add-domain-new/${uid}`,
                { storeName: storeName.trim() },
                { headers: { token } },
            );

            if (response.status === 200 && response.data.success) {
                localStorage.setItem('CreateStore', 'true');
                localStorage.setItem('storeName', storeName);
                const sub = response.data.subdomain;
                toast.success(`স্টোর তৈরি হয়েছে! আপনার স্টোর: ${sub}.ecomtechbd.com`);
                setTimeout(() => {
                    setLoading(false);
                    window.location.href = '/dashboard';
                }, 2500);
            }
        } catch (error) {
            setLoading(false);
            const errorMessage =
                error.response?.data ||
                error.message ||
                'স্টোর তৈরিতে সমস্যা হয়েছে';
            toast.error(errorMessage);
        }
    };

    return (
        <div className={styles.page} lang="bn">
            <ToastContainer />

            {/* Sticky top header */}
            <header className={styles.nav}>
                <div className={styles.navInner}>
                    <Link to="/" className={styles.brand}>
                        <span className={styles.brandLogo}>
                            <img src={`${process.env.PUBLIC_URL}/logo512.png`} alt="ইকমটেক" />
                        </span>
                        ইকমটেক
                    </Link>
                </div>
            </header>

            <main className={styles.main}>
                <div className={styles.card}>

                    <div className={styles.cardIcon}>
                        <StoreIcon />
                    </div>

                    <h1 className={styles.cardTitle}>
                        আপনার স্টোর তৈরি করুন
                    </h1>
                    <p className={styles.cardSub}>
                        ইকমটেকে স্বাগতম! কয়েক সেকেন্ডে আপনার অনলাইন স্টোর সেট আপ করুন।
                    </p>

                    {/* Tips box */}
                    <div className={styles.tips}>
                        <div className={styles.tipsTitle}>
                            <InfoIcon />
                            কুইক টিপস
                        </div>
                        <ul className={styles.tipsList}>
                            <li><Check /> ইউনিক ও মনে রাখার মতো একটা নাম বেছে নিন</li>
                            <li><Check /> শুধু letters, numbers, এবং hyphens ব্যবহার করুন</li>
                            <li><Check /> ২-২৮ অক্ষরের মধ্যে রাখুন</li>
                            <li><Check /> আপনার স্টোর URL হবে: <strong>e-yourname.ecomtechbd.com</strong></li>
                        </ul>
                    </div>

                    {/* Store name input */}
                    <div className={styles.field}>
                        <label className={styles.fieldLabel}>স্টোরের নাম</label>
                        <div className={styles.fieldInputWrap}>
                            <input
                                type="text"
                                placeholder="যেমন: myshop  (URL হবে e-myshop.ecomtechbd.com)"
                                value={storeName}
                                onChange={(e) => setStoreName(e.target.value)}
                                lang="en"
                                className={
                                    storeName
                                        ? isValid
                                            ? styles.inputValid
                                            : styles.inputInvalid
                                        : ''
                                }
                            />
                        </div>

                        {storeName && (
                            <div
                                className={`${styles.validationMessage} ${
                                    isValid ? styles.validValid : styles.validError
                                }`}
                            >
                                {isValid ? <Check /> : <AlertIcon />}
                                <span>{validationMessage}</span>
                            </div>
                        )}
                    </div>

                    {/* URL preview */}
                    {subdomain && isValid && (
                        <div className={styles.preview}>
                            <div className={styles.previewLabel}>
                                <GlobeIcon />
                                আপনার স্টোর URL preview
                            </div>
                            <div className={styles.previewUrl}>
                                https://<strong>e-{subdomain}</strong>.ecomtechbd.com
                            </div>
                        </div>
                    )}

                    {/* Submit button */}
                    <button
                        type="button"
                        className={styles.submitBtn}
                        onClick={handleStoreName}
                        disabled={loading || !isValid || !storeName}
                    >
                        {loading ? <span className={styles.spinner} /> : null}
                        {loading ? 'স্টোর তৈরি হচ্ছে…' : 'আমার স্টোর তৈরি করুন'}
                        {!loading && <ArrowRight />}
                    </button>

                    <p className={styles.helpText}>
                        সমস্যা হচ্ছে? আমাদের সাপোর্ট টিমের সাথে যোগাযোগ করুন।
                    </p>
                </div>
            </main>
        </div>
    );
}

export default SetStoreName;
